module.exports = __webpack_public_path__ + "de.d81d0ebbd974b1c77ad6.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/de.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/de.svg
// module chunks = styles